module.exports = __webpack_public_path__ + "3a6e6ed5821f4b36f90b8265b8a821cd.png";